// extracted by mini-css-extract-plugin
module.exports = {"container":"buy-crypto_container__1gqMI","button":"buy-crypto_button__32Z7g"};